/*
 * @Author: ylq
 * @Date: 2022-08-23 16:47:12
 * @Desc: Axios
 * @Last Modified by: ylq
 * @Last Modified time: 2025-04-27 16:04:57
 */

import axios from 'axios';
import CONFIG from '../config/config';
import qs from 'qs';
import router from '@/router';
import { getToken, clearToken } from './auth';
import { getKey } from './authkey';
import { Modal } from '@arco-design/web-vue';
// import useTimeOut from '@/hooks/time-out';
// import { h } from  'vue';
// import { IconInfoCircleFill } from '@arco-design/web-vue/es/icon';

// import useUserStore from '@/store/modules/user';
// --阻止重复发送请求----------------------------------------------------------------------------------
const pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
const cancelToken = axios.CancelToken;
// const { sendRobotMsg } = useTimeOut();
const removePending = (ever) => {
  for (const p in pending) {
    const apiIndex = ever.params && ever.params.apiIndex;
    let u = ever.url + '&' + ever.method;
    if (apiIndex) {
      u += '&' + apiIndex;
    }
    if (pending[p].u === u) {
      //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
};
// let startTime;
// --阻止重复发送请求----------------------------------------------------------------------------------

// json格式 payload
// let jsonHeaders = {
//   'Content-Type': 'application/json',
//   'X-Requested-With': 'XMLHttpRequest',
// }
// 创建一个新的axios实例
const http = axios.create({
  baseURL: '/api/',
  headers: {
    // formData 格式
    // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    // payload格式
    'Content-Type': 'application/json'
  },
  withCredentials: false,
  // transformRequest: [(data) => {
  //   // let td = 'data=' + encodeURIComponent(JSON.stringify(data))
  //   // console.log(td);
  //   // return JSON.stringify(data)
  //   return data
  // }],
  paramsSerializer: function (params) {
    // params = {data: params}
    return qs.stringify(params, { arrayFormat: 'brackets' });
    // return params
  },
  // 用于对相应数据进行处理
  // 它会通过then或者catch
  transformResponse: [
    function (data) {
      // 可以对data做任何操作
      const res = {
        error: null,
        paging: null,
        result: null,
        traceId: null
      };
      try {
        data = JSON.parse(data);
        const head = data.Header;
        if (head) {
          let err = null;
          if (head && head.Code !== 0) {
            err = { msg: head.Msg, code: head.Code };
          }
          let paging = null;
          let result = data.Data;
          if (result && result.page_info) {
            paging = result.page_info;
            result = result.list;
          }
          const myData = {
            error: err || null,
            paging,
            result: result || null,
            traceId: data.traceId
          };
          return myData;
        } else {
          let err = null;
          if (data.code !== 0) {
            err = { msg: data.msg, code: data.code };
          }
          let paging = null;
          let result = data.data;
          if (result && result.page_info) {
            paging = result.page_info;
            result = result.list;
          }
          const myData = {
            error: err || null,
            paging,
            result: result,
            traceId: data.traceId
          };
          return myData;
        }
      } catch {
        console.log(88, res);
        return data;
      }
    }
  ]
  // timeout: 10 * 1000
});

// 添加请求拦截器
http.interceptors.request.use(
  (config) => {
    // loading
    // 发送请求类型，默认改为post
    // config.mt ? config.method = config.mt : config.method = 'POST';
    // 发送数据格式 json  如果需要form/data 增加hdt 属性，值为fd
    // if (config.headers["Content-Type"] === "multipart/form-data") {
    //   console.log(config.headers)
    //   // config.headers = fdHeaders
    // }
    // 获取token
    // let token = storage.getItem(CONFIG.TOKEN) || null;
    // if (token) {
    //   config.headers['Access-Token'] = token
    // }
    // 获取token
    // let token = storage.getItem(CONFIG.TOKEN) || null;
    const token = getToken() || null;
    if (token && !config?.notAuth) {
      config.headers['authorization'] = `Bearer ${token}`;
    }

    // 应后端要求，增加了一个source，用于后端统计来源 S ylq 2024-11-21
    config.headers['source'] = `${window?.h5sdk ? 'pcfs' : 'pcweb'}`;
    // 应后端要求，增加了一个source，用于后端统计来源 E ylq 2024-11-21

    const params = new URL(location.href);
    const searchParams = params.searchParams;
    // 给后端传大key和小key
    const k = searchParams.get('key');
    const ak = searchParams.get('skey');
    if (k) {
      config.headers['fh-key'] = `${k}`;
    }
    if (ak) {
      config.headers['fh-app-Key'] = `${ak}`;
    }
    // console.log(token)
    // 提交数据格式转化
    // console.log(config)
    // ------------------------------------------------------------------------------------
    removePending(config); //在一个ajax发送前执行一下取消操作
    config.cancelToken = new cancelToken((c) => {
      const apiIndex = config.params && config.params.apiIndex;
      // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      let u = config.url + '&' + config.method;
      if (apiIndex) {
        u += '&' + apiIndex;
      }
      //  console.log(u)
      pending.push({ u, f: c });
    });
    // ------------------------------------------------------------------------------------
    // startTime = new Date();
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
let modal = null;
// 添加响应拦截器
http.interceptors.response.use(
  (response) => {
    // 返回超过1秒调起机器人通知接口
    // const duration = new Date() - startTime;
    // console.log(209999, 17666, duration, response.config.url);
    // // const url = response.config.url;
    // // const pne = window.performance?.getEntriesByType('resource')?.find((el) => el.initiatorType === 'xmlhttprequest' && el.name.indexOf(`${location.origin}/api/`) > -1 && el.name.indexOf(`${url}`) > -1);
    // // console.log(17666, pne);
    // if (duration) {
    //   // const duration = pne?.duration;
    //   // const reqPrevTime = pne.requestStart - pne.startTime;
    //   // const waitResTime = pne.responseStart - pne.requestStart;
    //   // const downTime = pne.responseEnd - pne.responseStart;
    //   // console.log(176662, pne.name, pne.duration, reqPrevTime,'Waiting for server response:', pne.responseStart - pne.requestStart, 'Content download', pne.responseEnd - pne.responseStart);

    //   if (duration > 1000) {
    //     // 获取请求的详细信息
    //     console.log(209999, response);
    //     const { url, params, data } = response.config;
    //     const { traceId } = response.data;
    //     const warningMsg = `访问地址：${location.href}, \r\n 请求返回时长：${duration}ms, 请求 URL: ${url} ${params ? ', 请求参数params: ' + JSON.stringify(params) : ''} ${data ? ', 请求体body: ' + JSON.stringify(data) : ''}`;
    //     const o = {
    //       errMsg: warningMsg,
    //       url,
    //       params,
    //       data,
    //       duration,
    //       // reqPrevTime,
    //       // waitResTime,
    //       // downTime,
    //       traceId
    //     };
    //     sendRobotMsg(o);
    //   }
    // }
    // ------------------------------------------------------------------------------------------
    removePending(response.config); //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    // -------------------------------------------------------------------------------------------
    const rd = response.data;
    // console.log(145, JSON.stringify(rd), rd.error);
    console.log(145, rd.error);
    const logoutCode = [10006, 10007, 10008];
    if (rd.error && logoutCode.indexOf(rd.error.code) > -1) {
      // const { logout } = useUserStore();
      // logout();
      clearToken();
      router.replace({
        name: 'login',
        query: { back: router.currentRoute.fullPath }
      });
    } else if (rd.error?.code === 10020) {
      if (!modal) {
        modal = Modal.info({
          // titleAlign: 'start',
          title: '提示',
          // title: () => h('div', [
          //   h(IconInfoCircleFill, {style: 'font-size: 24px'}, ),
          //   h('span', '提示')
          // ]),
          modalClass: 'fh-modal-switch-key',
          content: '当前登录账号身份已变更,请刷新后重试',
          okText: '刷新',
          width: 400,
          closable: false,
          escToClose: false,
          maskClosable: false,
          onOk: () => {
            const { key, skey } = getKey();
            console.log(key, skey, `${location.origin}${location.pathname}?key=${key}&skey=${skey}`);
            modal = null;
            window.location.href = `${location.origin}?key=${key}&skey=${skey}`;
          }
        });
      } else {
        rd.error = null;
      }
    } else {
      // 存储当前时间
      localStorage.setItem(CONFIG.LAST_LOGIN_TIME, Date.now());
    }
    return rd;
  },
  (error) => {
    console.log(18722, error);
    const status = error?.response?.status;
    console.log(187555, status, error, error?.response);

    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      // 处理超时问题
      console.error('请求超时，请稍后再试！');
      // const o = {
      //   errMsg: `请求超时`,
      //   url: error?.config?.url,
      //   duration: error?.config?.timeout,
      //   type: 1
      // };
      // sendRobotMsg(o);
    }
    if (status >= 500) {
      error.message = `网络异常，请刷新后重试 （${status}）`;
    }
    if (error.code === 'ERR_CANCELED') {
      error.errCode = 'ERR_CANCELED';
      console.log(23999, error);
      return new Promise(() => {});
    } else {
      error.errCode = status;
    }
    return Promise.reject(error);
  }
);

// 导出axios
export { http as axios };
